import ImagesCarousel from '../components/images-carousel';
import HeroNav from '../components/hero-nav';
import Nav from '../components/nav';
import PrimaryTeaserCarousel from '../components/primary-teaser-carousel';
import HeroProductCarousel from '../components/hero-product-carousel';
import SliderCarousel from '../components/slider-carousel';
import Accordion from '../components/accordion';
import Tabs from '../components/tabs';
import HotspotCarousel from '../components/hotspot-carousel';
import CustomSelect from '../components/custom-select';
import NumberInput from '../components/number-input';
import Popup from '../components/popup';
import FormPopup from '../components/form-popup';
import ConfigurationSlider from '../components/configuration-slider';
import ScrollDown from '../components/scroll-down';
import Hotspot from '../components/hotspot';
import ProductSingle from '../components/product-single/index';
import QuickCart from '../components/cart/quick';
import Cart from '../components/cart/index';
import Search from '../components/search';
import ThankYou from '../components/checkout/thank-you';
import FullScreenSliderCarousel from '../components/fullscreen-slider-carousel';
import PrimarySliderTeaser from '../components/primary-slider-teaser';
import ScrollingIndicator from '../components/scrolling-indicator';
import CheckoutCompanySwitch from '../components/checkout-company-switch';
import ShareButtons from '../components/share-buttons';
import PictureTeaser from '../components/picture-teaser';
import PictureTeaserInnerCarousel from '../components/picture-teaser-inner-carousel';
import FormValidation from '../components/form-validation';
import LanguageSwitcher from '../components/language-switcher';
import C2APictureVideo from '../components/c2a-picture-video';
import LoggedIn from '../components/logged-in';
import SeeAllProducts from '../components/see-all-products';
import ProductRequest from '../components/product-request';
import TemplateDownloadsType from '../components/template-downloads-type';
import TemplateDownloads from '../components/template-downloads';
import TemplateFaqArchive from '../components/template-faq-archive';
import Account from '../components/account';
import ButtonDownloadHandler from '../components/download-button-handler';
import Materials from '../components/materials';
import VideoTeaserV2 from '../components/video-teaser-v2';
import TwoColumnHeroSlider from '../components/two-column-hero-slider';
import Map from '../components/map';
import NewsletterC2A from '../components/newsletter-c2a';
import HeroBlog from '../components/hero-blog';
import ProductSlider from '../components/product-slider';
import ProductAccordionSlider from '../components/product-accordion-slider';
import BlogPostsFilter from '../components/blog-posts-filter';
import InspirationSidebar from '../components/inspiration-sidebar';
import { flashMessageBoxDismiss } from '../components/message-box';
import ProductList from '../components/product-list';
import ProductListTeaser from '../components/product-list-teaser';
import Video from '../components/video';
import ProductFilterPresets from '../components/product-filter-presets';
import Parallax from '../components/parallax';
import Sidebar from '../components/sidebar';
import Breadcrumb from '../components/breadcrumb';
import PictureTeaserVideo from '../components/picture-teaser-video';
import AddToWishlistIcon from '../components/add-to-wishlist-icon';
import LookbookSidebar from '../components/lookbook-sidebar';
import RoomleIframe from '../components/roomle-iframe';
import ProductStickyBar from '../components/product-sticky-bar';
import LayoutLightboxImages from '../components/layout-lightbox-images';
import LayoutFormMaterials from '../components/layout-form-materials';
import LayoutLightboxVideo from '../components/layout-lightbox-video';
import RoomleMessageHandler from '../components/roomleMessageHandler';
import RoomlePopupRequestPrice from '../components/roomle-popup-request-price';
import BlogEntrySliderCarousel from '../components/blog-entry-slider-carousel';
import BlogPostsLoadMore from '../components/blog-posts-load-more';
import BlogShareButton from '../components/blog-share-button';
import ContactBar from '../components/contact-bar';
import WelcomeBubble from '../components/welcome-bubble';
import MaterialGallery from '../components/material-gallery';
import Registration from '../components/registration';
import Tooltips from '../components/tooltips';
import ConversionElementsComponent from '../components/conversion-elements';
import ModalImageVideoSlider from '../components/modal-image-video-slider';
import FormEditPersonal from '../components/form-edit-personal';
import PopupRegisterAccountLogin from '../components/popup-register-account-login';
import HeroNavMobileCarousel from '../components/hero-nav-mobile-slider';
import PriceAdjuster from '../components/price-adjuster';
import { saveUtmData } from '../utils/utm';

class MainController {
  initDynamicInclude() {
    window.addEventListener('servd.dynamicloaded', (e: Event) => {

      const components = [
        new LoggedIn(),
        new Popup(),
        new FormPopup(),
        new QuickCart(),
        new LanguageSwitcher(),
        new WelcomeBubble(),
        new NumberInput(),
        new AddToWishlistIcon(),
        new ProductSingle(),
        new LayoutFormMaterials(),
        new ButtonDownloadHandler(),
        new RoomleIframe(),
        new RoomleMessageHandler(),
        new PriceAdjuster(),
        new ProductRequest(),
        new RoomlePopupRequestPrice(),
      ];

      saveUtmData();
      flashMessageBoxDismiss();

      components.forEach((component) => {
        component.init();
      });


      document.querySelectorAll('.js-o-product-list')?.forEach((el) => {
        const productList = new ProductList(el as HTMLElement);
        productList.init();
      });

      document.querySelectorAll('.js-product-list-teaser')?.forEach((el) => {
        const productListTeaser = new ProductListTeaser(el as HTMLElement);
        productListTeaser.init();
      });

      document.querySelectorAll('.js-popup__download-mail__slider')?.forEach((slider) => {
        const imageSliderInstance = new ModalImageVideoSlider(slider as HTMLElement);
        imageSliderInstance.init();
      });
    });
  }

  init() {
    const components = [
      new Nav(),
      new SliderCarousel(),
      new Accordion(),
      new Tabs(),
      new Hotspot(),
      new CustomSelect(),
      // new NumberInput(),
      new ScrollDown(),
      // new ConfigurationSlider(),
      // new ProductSingle(),
      // new QuickCart(),
      new Cart(),
      // new Search(),
      new ThankYou(),
      new ScrollingIndicator(),
      new CheckoutCompanySwitch(),
      new ShareButtons(),
      new FormValidation('.js-form-validate'),
      // new LanguageSwitcher(),
      // new ProductRequest(),
      new C2APictureVideo(),
      new SeeAllProducts(),
      new VideoTeaserV2(),
      new TwoColumnHeroSlider(),
      new Map(),
      new Account(),
      new NewsletterC2A(),
      new HeroBlog('.js-hero-blog'),
      new InspirationSidebar(),
      new BlogPostsFilter(),
      new Video(),
      new Parallax(),
      new Sidebar(),
      new Breadcrumb(),
      // new AddToWishlistIcon(),
      new LookbookSidebar(),
      // new RoomleIframe(),
      new Materials(),
      new ProductStickyBar(),
      new LayoutLightboxImages(),
      new LayoutLightboxVideo(),
      // new RoomleMessageHandler(),
      // new RoomlePopupRequestPrice(),
      new BlogEntrySliderCarousel(),
      new BlogShareButton(),
      new ContactBar(),
      new MaterialGallery(),
      new Registration(),
      new Tooltips(),
      new ConversionElementsComponent(),
      new FormEditPersonal(),
      new PopupRegisterAccountLogin(),
      new HeroNav(),
    ];

    const pictureTeasers = document.querySelectorAll('.js-picture-teaser-carousel') as NodeListOf<HTMLElement> | null;
    pictureTeasers?.forEach((pictureTeaser: HTMLElement) => {
      if (Number(pictureTeaser.dataset.items) > 3) {
        const pictureTeaserInstance = new PictureTeaser(pictureTeaser);
        pictureTeaserInstance.init();
      }
    });

    const pictureTeaserSlides = document.querySelectorAll('.js-picture-teaser-carousel__slide') as NodeListOf<HTMLElement> | null;
    pictureTeaserSlides?.forEach((pictureTeaserSlide: HTMLElement) => {
      if (pictureTeaserSlide.dataset.hasvideo == 'true') {
        const pictureTeaserVideoInstance = new PictureTeaserVideo(pictureTeaserSlide);
        pictureTeaserVideoInstance.init();
      }
    });

    const heroNavMobileSliders = document.querySelectorAll('.js-o-hero-nav-mobile-slider') as NodeListOf<HTMLElement> | null;
    heroNavMobileSliders?.forEach((item: HTMLElement) => {
      const heroNavMobileSlidersInstance = new HeroNavMobileCarousel(item);
      heroNavMobileSlidersInstance.init();
    });

    const pictureTeasersInnerItems = document.querySelectorAll('.js-picture-teaser-item-carousel') as NodeListOf<HTMLElement> | null;
    pictureTeasersInnerItems?.forEach((pictureTeaser: HTMLElement) => {
      const pictureTeasersInnerItemsInstance = new PictureTeaserInnerCarousel(pictureTeaser);
      pictureTeasersInnerItemsInstance.init();
    });

    const EditorialImageSlider = document.querySelectorAll('.js-images-carousel') as NodeListOf<HTMLElement> | null;
    EditorialImageSlider?.forEach((slider: HTMLElement) => {
      const slides = slider.querySelectorAll('.swiper-slide');

      if (slides.length > 1) {
        const EditorialImageSliderInstance = new ImagesCarousel(slider);
        EditorialImageSliderInstance.init();
      }
    });

    const primarySliderTeaser = document.querySelectorAll('.js-o-primary-slider-teaser') as NodeListOf<HTMLElement> | null;
    primarySliderTeaser?.forEach((sliderTeaser: HTMLElement) => {
      const slides = sliderTeaser.querySelectorAll('.swiper-slide');

      if (slides.length > 1) {
        const primarySliderTeaserInstance = new PrimarySliderTeaser(sliderTeaser);
        primarySliderTeaserInstance.init();
      }
    });

    const primaryTeaserSlider = document.querySelectorAll('.js-primary-teaser-carousel') as NodeListOf<HTMLElement> | null;
    primaryTeaserSlider?.forEach((slider: HTMLElement) => {
      const slides = slider.querySelectorAll('.swiper-slide');

      if (slides.length > 1) {
        const primaryTeaserSliderInstance = new PrimaryTeaserCarousel(slider);
        primaryTeaserSliderInstance.init();
      }
    });

    const fullscreenSlider = document.querySelectorAll('.js-o-fullscreen-slider-carousel') as NodeListOf<HTMLElement> | null;
    fullscreenSlider?.forEach((slider: HTMLElement) => {
      const slides = slider.querySelectorAll('.swiper-slide');

      if (slides.length > 1) {
        const fullscreenSliderInstance = new FullScreenSliderCarousel(slider);
        fullscreenSliderInstance.init();
      }
    });

    const configurationSlider = document.querySelectorAll('.o-configuration-slider') as NodeListOf<HTMLElement> | null;
    configurationSlider?.forEach((slider: HTMLElement) => {
      const slides = slider.querySelectorAll('.js-o-configuration-slider .swiper-slide');

      if (slides.length > 1) {
        const configurationSliderInstance = new ConfigurationSlider(slider);
        configurationSliderInstance.init();

        // const configurationContentSliderEl = slider.closest('.o-configuration-slider')?.querySelector('.js-o-configuration-slider__features');
        // const configurationContentSliderInstance = new ConfigurationContentSlider(configurationContentSliderEl, {}, configurationSliderInstance);
        // configurationContentSliderInstance.init();
      }
    });

    const hotspotCarouselSlider = document.querySelectorAll('.js-hotspot-carousel') as NodeListOf<HTMLElement> | null;
    hotspotCarouselSlider?.forEach((slider: HTMLElement) => {
      const slides = slider.querySelectorAll('.swiper-slide');

      if (slides.length > 1) {
        const hotspotCarouselSliderInstance = new HotspotCarousel(slider);
        hotspotCarouselSliderInstance.init();
      }
    });

    const validatedForms = document.querySelectorAll('.js-form-validate') as NodeListOf<HTMLFormElement> | null;
    validatedForms?.forEach((validatedForm) => {
      components.push(new FormValidation(validatedForm));
    });

    document.querySelectorAll('.js-o-pfp')?.forEach((el) => {
      const t = new ProductFilterPresets(el as HTMLElement);
      t.init();
    });

    document.querySelectorAll('.js-t-downoads-type')?.forEach((el) => {
      const t = new TemplateDownloadsType(el as HTMLElement);
      t.init();
    });

    document.querySelectorAll('.js-t-downoads')?.forEach((el) => {
      const t = new TemplateDownloads(el as HTMLElement);
      t.init();
    });

    document.querySelectorAll('.js-t-faq-archive')?.forEach((el) => {
      const t = new TemplateFaqArchive(el as HTMLElement);
      t.init();
    });

    document.querySelectorAll('.js-product-slider')?.forEach((el) => {
      const productSlider = new ProductSlider(el as HTMLElement);
      productSlider.init();
    });

    document.querySelectorAll('.js-product-accordion-slider')?.forEach((el) => {
      const productAccordionSlider = new ProductAccordionSlider(el as HTMLElement);
      productAccordionSlider.init();
    });

    document.querySelectorAll('.js-blog-tabs__content')?.forEach((el) => {
      const blogLoadMore = new BlogPostsLoadMore(el as HTMLElement);
      blogLoadMore.init();
    });

    flashMessageBoxDismiss();

    components.forEach((component) => {
      component.init();
    });
  }
}

export default MainController;
